export default __webpack_public_path__ + "static/media/close.e950e71a69cf4464f585c220a034a0d0.svg";